// A list of components that need to be used outside of a Svelte app (mixed with plain HTML)
const components = {
  'components/admin/HomeImageManager': () => import('./components/admin/HomeImageManager'),
  'components/HeaderBar/DonationHeader': () => import('./components/HeaderBar/DonationHeader.svelte'),
  'components/Share': () => import('./components/Share.svelte'),
  'components/PublicationList': () => import('./components/PublicationList/PublicationList.svelte'),
}

/*
  This method creates Svelte components from existing HTML tags, allowing individual components to be used outside of a
  Svelte-based application, mixed with plain HTML. The component to be created is specified using the data-component
  prop. For example:

  <div data-component="components/admin/CarouselPhotos.svelte" />

  Add props via data-* attributes use dashes and lowercase letters. kebab-case will be converted into camelCase as described here:
  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset#name_conversion

  <div data-component="components/PublicationList" data-config-filename="config.json"/>
 */
const initialize = (): void => {
  const componentNodes = document.querySelectorAll<HTMLElement>('[data-component]')

  componentNodes.forEach(node => {
    const componentName = node.getAttribute('data-component') as keyof typeof components

    const componentFn = components[componentName]
    if (componentFn) {
      void componentFn().then(({ default: component }) => {
        const dataAttributes = node.dataset
        const props: { [name: string]: string } = {}
        for (const key in dataAttributes) {
          const attr = dataAttributes[key]
          if (key !== 'component' && attr) {
            props[key] = attr
          }
        }

        new component({
          target: node,
          props,
        })
      })
    }
  })
}

export default initialize

declare global {
  interface Window {
    initialize: () => void
  }
}

window.initialize = initialize
